import defaultNHLLogo from "../assets/images/nhl_logo.png";
import default_NBA_Logo from "../assets/images/nba-logo.png";
import default_MLB_Logo from "../assets/images/mlb_logo.png";
import default_MLS_Logo from "../assets/images/mls_logo.png";
import default_nfl_Logo from "../assets/images/nfl_logo.png";
import default_ncaa_fb_Logo from "../assets/images/ncaa_fb_logo.png";

export const DEV_API = "";
// export const DEV_API = "http://localhost:5001";

// export const DEV_API = "https://ballhog-04c596ad85aa.herokuapp.com";
// export const SOCKET_SERVER = "https://ballhog-04c596ad85aa.herokuapp.com:5002";
export const DEV_SOCKET_SERVER = "http://localhost:5002";

export const WIN_POINT_RULES = {
  5: 18.5,
  10: 37,
  25: 92.5,
  50: 185,
  100: 370,
};

export const WIN_POINT_RULES_1V1 = {
  5: 9.5,
  10: 19,
  25: 47.5,
  50: 95,
  100: 190,
};

export const PAYOUT = {
  1: "1V4",
  2: "1V1",
};

export const PAYOUT_TYPE = {
  "1V4": 1,
  "1V1": 2,
};

export const Logo = {
  NHL3: defaultNHLLogo,
  NHL_NEW: defaultNHLLogo,
  NCAA: defaultNHLLogo,
  SOCCER: default_MLS_Logo,
  MLB: default_MLB_Logo,
  MLB_NEW: default_MLB_Logo,
  NFL: default_nfl_Logo,
  NFL2: default_nfl_Logo,
  NCAAFB: default_ncaa_fb_Logo,
  NCAAFB2: default_ncaa_fb_Logo,

  NBA3: default_NBA_Logo,
  NBA_NEW: default_NBA_Logo,
  NCAABB2: default_ncaa_fb_Logo,
  SOCCER_NEW: default_MLS_Logo,
};

export const URL = {
  NCAA_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/basketball/mens-college-basketball/scoreboard",
  SOCCER_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/soccer/eng.1/scoreboard",
  MLB_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/baseball/mlb/scoreboard",
  MLB_NEW_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/baseball/mlb/scoreboard",
  NFL_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/football/nfl/scoreboard",
  NFL2_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/football/nfl/scoreboard",
  NHL_NEW_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/hockey/nhl/scoreboard",
  NCAAFB_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/football/college-football/scoreboard",
  NCAAFB2_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/football/college-football/scoreboard",

  NHL3_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/hockey/nhl/scoreboard",
  NBA3_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/basketball/nba/scoreboard",
  NBA_NEW_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/basketball/nba/scoreboard",
  NCAABB2_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/basketball/mens-college-basketball/scoreboard",
  NCAABB_NEW_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/basketball/mens-college-basketball/scoreboard",
  SOCCER_NEW_TODAY_EVENT:
    "https://site.api.espn.com/apis/site/v2/sports/soccer/eng.1/scoreboard",
  // https://site.api.espn.com/apis/site/v2/sports/basketball/mens-college-basketball/summary
  // EVENT_SCHEDULE: 'https://www.espn.com/nba/schedule',

  // Event API
  NCAA: "https://site.api.espn.com/apis/site/v2/sports/basketball/mens-college-basketball/summary",
  SOCCER1: "https://site.api.espn.com/apis/site/v2/sports/soccer/eng.1/summary",
  SOCCER: "https://site.api.espn.com/apis/site/v2/sports/soccer/usa.1/summary",
  // NCAA_SCORE_BOARD: "http://site.api.espn.com/apis/site/v2/sports/basketball/mens-college-basketball/scoreboard"
  MLB: "https://site.api.espn.com/apis/site/v2/sports/baseball/mlb/summary",
  MLB_NEW: "https://site.api.espn.com/apis/site/v2/sports/baseball/mlb/summary",
  NFL: "https://site.api.espn.com/apis/site/v2/sports/football/nfl/summary",
  NFL2: "https://site.api.espn.com/apis/site/v2/sports/football/nfl/summary",
  NCAAFB:
    "https://site.api.espn.com/apis/site/v2/sports/football/college-football/summary",
  NCAAFB2:
    "https://site.api.espn.com/apis/site/v2/sports/football/college-football/summary",

  NHL3: "https://site.api.espn.com/apis/site/v2/sports/hockey/nhl/summary",
  NHL_NEW: "https://site.api.espn.com/apis/site/v2/sports/hockey/nhl/summary",
  NBA3: "https://site.api.espn.com/apis/site/v2/sports/basketball/nba/summary",
  NBA_NEW:
    "https://site.api.espn.com/apis/site/v2/sports/basketball/nba/summary",
  NCAABB2:
    "https://site.api.espn.com/apis/site/v2/sports/basketball/mens-college-basketball/summary",
  NCAABB_NEW:
    "https://site.api.espn.com/apis/site/v2/sports/basketball/mens-college-basketball/summary",
  SOCCER_NEW:
    "https://site.api.espn.com/apis/site/v2/sports/soccer/usa.1/summary",
};

export const SPORTS_CATEGORY = [
  {
    label: "NFL2",
    value: "NFL2",
  },
  {
    label: "NCAA FB2",
    value: "NCAAFB2",
  },
  {
    label: "MLB NEW",
    value: "MLB_NEW",
  },
  {
    label: "NHL NEW",
    value: "NHL_NEW",
  },
  {
    label: "NBA NEW",
    value: "NBA_NEW",
  },
  {
    label: "NCAABB NEW",
    value: "NCAABB_NEW",
  },
  {
    label: "SOCCER NEW",
    value: "SOCCER_NEW",
  },
  {
    label: "NBA",
    value: "NBA3",
  },
  {
    label: "NCAA BB",
    value: "NCAABB2",
  },
  {
    label: "MLB",
    value: "MLB",
  },
  {
    label: "NHL",
    value: "NHL3",
  },
  {
    label: "SOCCER",
    value: "SOCCER",
  },
  {
    label: "NFL",
    value: "NFL",
  },
  {
    label: "NCAA FB",
    value: "NCAAFB",
  },
];

export const INTERVAL_TIME = [
  {
    label: "3s",
    value: 3,
  },
  {
    label: "4s",
    value: 4,
  },
  {
    label: "5s",
    value: 5,
  },
  {
    label: "6s",
    value: 6,
  },
  {
    label: "7s",
    value: 7,
  },
  {
    label: "8s",
    value: 8,
  },
  {
    label: "9s",
    value: 9,
  },
  {
    label: "10s",
    value: 10,
  },
  {
    label: "20s",
    value: 20,
  },
  {
    label: "30s",
    value: 30,
  },
];

export const TEAM_LIST = [
  {
    label: "Team1",
    value: 0,
  },
  {
    label: "Team2",
    value: 1,
  },
  {
    label: "Team3",
    value: 2,
  },
  {
    label: "Team4",
    value: 3,
  },
];

// export const DATASET_TYPE_CATEGORY = {
//     NCAA: NCAA_DS,
//     NHL3: NHL3_DS,
//     SOCCER: SOCCER_DS,
//     MLB: MLB_DS,
//     NFL: NFL_DS,
//     NCAAFB: NCAAFB_DS,

//     NBA3: NBA3_DS,
//     NCAABB2: NCAABB2_DS,
// }
